var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMedicalServices(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "medical_services"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1109_3104",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1109_3104)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "medical_services_2",
    d: "M2.48425 14.7781C2.13987 14.7781 1.84335 14.6538 1.59468 14.4051C1.34601 14.1564 1.22168 13.8599 1.22168 13.5155V5.20394C1.22168 4.85884 1.34601 4.5617 1.59468 4.31251C1.84335 4.06332 2.13987 3.93872 2.48425 3.93872H5.23098V2.38317C5.23098 2.04066 5.35531 1.74461 5.60398 1.49501C5.85265 1.24541 6.14917 1.12061 6.49355 1.12061H9.50635C9.85072 1.12061 10.1472 1.24541 10.3959 1.49501C10.6446 1.74461 10.7689 2.04066 10.7689 2.38317V3.93872H13.5156C13.8608 3.93872 14.1579 4.06332 14.4071 4.31251C14.6563 4.5617 14.7809 4.85884 14.7809 5.20394V13.5155C14.7809 13.8599 14.6563 14.1564 14.4071 14.4051C14.1579 14.6538 13.8608 14.7781 13.5156 14.7781H2.48425ZM2.48425 13.5155H13.5156V5.20394H2.48425V13.5155ZM6.49355 3.93872H9.50635V2.38317H6.49355V3.93872ZM7.36866 9.99102V11.991H8.63123V9.99102H10.6312V8.72847H8.63123V6.72847H7.36866V8.72847H5.36866V9.99102H7.36866Z",
    fill: "#4B628A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalServices);
export default __webpack_public_path__ + "static/media/medical_services.7af72972e5e09d6799909245077587e9.svg";
export { ForwardRef as ReactComponent };